module.exports = __webpack_public_path__ + "static/media/close.5c1e930f.svg";